module.exports = __webpack_public_path__ + "static/media/bullet.6be3462b.png";